import { DirectDebitState } from './types';

export const state = (): DirectDebitState => initialState();

export const initialState = (): DirectDebitState => ({
  directDebit: undefined,
  creditTransferForTrainers: undefined,
});
